'use client';
import Container from '@/components/ui/Container';
import ContactUsForm from '@/components/contact/ContactUsForm';
import Image from 'next/image';
import React from 'react';
import HeroSectionHeading from '@/components/ui/HeroSectionHeading';
import Link from 'next/link';
import { contactDetails, contactUs } from '../utils/Constant';

const ContactUs = () => {
  return (
    <>
      <div className="px-4 pb-10 pt-5">
        <Container className="flex flex-col justify-between gap-10 rounded-3xl bg-contactUs bg-full bg-no-repeat py-20 lg:flex-row">
          <div className="flex flex-col gap-6">
            <HeroSectionHeading
              heading={contactUs?.title}
              description={contactUs?.description}
              headingStyle="text-white"
              descriptionStyle="text-white"
            />
            <div className="h-[1px] w-full bg-rostedWhite"></div>
            <div className="flex flex-col gap-5 sm:flex-row sm:items-center">
              <Link
                href={`tel:${contactDetails?.cno}`}
                className="flex items-center gap-2 font-opt text-base font-normal leading-5 text-white"
              >
                <Image
                  src={contactDetails?.cnoi}
                  alt="call-icon"
                  width={18}
                  height={18}
                />
                <span>{contactDetails?.cno}</span>
              </Link>
              <Link
                href={`mailto:${contactDetails?.cmail}`}
                className="flex items-center gap-2 font-opt text-base font-normal leading-5 text-white"
              >
                <Image
                  src={contactDetails?.cmaili}
                  alt="email-icon"
                  width={18}
                  height={18}
                />
                <span>{contactDetails?.cmail}</span>
              </Link>
            </div>
            <div className="h-[1px] w-full bg-rostedWhite"></div>
            <div className="flex items-start gap-3">
              <Image
                src={contactDetails?.clocationi}
                alt="location-icon"
                width={22}
                height={22}
                className=""
              />
              <span className="max-w-[500px] font-opt text-base font-normal leading-6 text-white">
                {contactDetails?.clocation}
              </span>
            </div>
          </div>
          <div className="flex w-full max-w-[500px] flex-col gap-5">
            <h2 className="font-opt text-4xl font-semibold leading-[42px] text-white">
              {contactUs?.formTitle}
            </h2>
            <ContactUsForm />
          </div>
        </Container>
      </div>
    </>
  );
};

export default ContactUs;
